//const App =  require("./App.vue").default;

// const vSelect = require("vue-select");
const $ = require('jquery')
import Vue, {createApp} from 'vue'
//const RegisterForm  =require("@/apps/rever-academy/components/RegisterForm.vue").default;
//const OwlCarousel = require('@/apps/rever-academy/components/OwlCarousel.vue').default
import 'jquery-datetimepicker'
import VFooter from "@/apps/rever-academy/components/Footer.vue"
// const App = require("./App").default;
const ReadyForRegister =require( "@/apps/rever-academy/components/ReadyForRegister.vue").default
import Mixin from './mixin'
import RegisterForm from "@/apps/rever-academy/components/RegisterForm.vue";
// import RegisterForm from "./components/RegisterForm1.vue";
import carousel from "vue-owl-carousel"
import OwlCarousel from "@/apps/rever-academy/components/OwlCarousel.vue";
import VueLazyload from 'vue-lazyload'
//$.datetimepicker.setLocale('vi')
import vSelect from 'vue-select'



const app = createApp({
  components: { VFooter, RegisterForm,OwlCarousel },
  mixins: [Mixin],
  mounted: function() {
    $('a[href="#"]').click(e => {
      e.preventDefault()
    })


    let imgLazyScript = document.createElement('script')
    imgLazyScript.text = "Defer.dom('img.lazy, div.lazy-bg');"
    document.head.appendChild(imgLazyScript)
    let bgLazyScript = document.createElement('script')
    bgLazyScript.text = "Defer.dom('.lazy-bg');"
    document.head.appendChild(bgLazyScript)
  },
  data() {
    return {
      openSidenav: false
    }
  } ,
  watch: {
    openSidenav() {
      if (this.openSidenav) {
        $('.bg-over').fadeIn(250)
      } else {
        $('.bg-over').fadeOut(350)
      }
    }
  },
   method: {
    // handleRegisterFormShow() {
    //   (this.$refs.registerForm as InstanceType<typeof RegisterForm>).show()
    // }
   } ,
  computed: {
    relatedPostOptions() {
      return {
        loop: true,
        margin: 10,
        nav: false,
        autoplay: true,
        autoplayTimeout: 8000,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          1000: {
            items: 3
          }
        }
      }
    },
    bannerOptions() {
      return {
        loop: true,
        nav: true,
        autoplay: true,
        autoplayTimeout: 5000,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      }
    },
    danhgiaOptions() {
      return {
        loop: true,
        margin: 10,
        nav: true,
        autoplay: true,
        autoplayTimeout: 10000,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      }
    },
    agents() {
      return [
        {
          thumbnail: `https://academy.rever.vn/images/hv1.jpg`,
          name: 'Nguyễn Thị Dịu',
          job_title: 'Sales Agent',
          description:
            'Giảng viên của lớp Red16 có một cách truyền đạt rất sát với tâm lý của học viên. Giảng viên chia sẻ rất nhiệt tình về những kinh nghiệm quý báu của mình để các học viên được truyền cảm hứng và động lực.'
        },
        {
          thumbnail: `https://academy.rever.vn/images/hv2.png`,
          name: 'Trần Thị Mai Uyên',
          job_title: 'Sales Agent',
          description:
            'Môi giới bất động sản không chỉ là một cơ hội việc làm mà còn là một sự nghiệp. Red16 không chỉ mang đến Kiến thức, kinh nghiệm để tạo niềm tin, sự tự chủ trong nghề nghiệp mà còn giúp người môi giới tạo ra thu nhập trong quá trình học.'
        },
        {
          thumbnail: `https://academy.rever.vn/images/hv3.png`,
          name: 'Huỳnh Phúc Thanh',
          job_title: 'Sales Manager',
          description:
            'Khóa học chưa kết thúc nhưng đã có học viên đạt từ ba đến bốn giao dịch thật sự, đó không chỉ là thành quả do chính học viên tạo ra mà còn đến từ những kiến thức hữu ích và quý giá của giáo trình Red16.'
        }
      ]
    },
    articles() {
      return [
        {
          url: 'https://agent.rever.vn/blog/rut-ngan-khoang-cach-thanh-cong-bang-lo-trinh-dao-tao-chuyen-sau-tai-rever',
          thumbnail: 'https://agent.rever.vn/hubfs/VN_08629.jpg',
          title: 'Rút ngắn khoảng cách thành công bằng lộ trình đào tạo chuyên sâu tại Rever'
        },
        {
          url: 'https://agent.rever.vn/blog/khoa-hoc-moi-gioi',
          thumbnail: 'https://agent.rever.vn/hubfs/unnamed%20%281%29-Feb-11-2022-06-32-04-64-AM.jpg',
          title: '5 lý do bạn nên tham dự một khóa học môi giới'
        },
        {
          url: 'https://agent.rever.vn/blog/bi-quyet-trau-doi-ky-nang-giao-tiep-voi-khach-hang-tu-trac-nghiem-disc',
          thumbnail:
            'https://agent.rever.vn/hubfs/X%C3%A2y%20d%E1%BB%B1ng%20k%E1%BB%B9%20n%C4%83ng%20giao%20ti%E1%BA%BFp%20v%E1%BB%9Bi%20kh%C3%A1ch%20h%C3%A0ng%20ti%E1%BB%81m%20t%E1%BB%AB%20tr%E1%BA%AFc%20nghi%E1%BB%87m%20DISC%20%282%29.png',
          title: 'Bí quyết trau dồi kỹ năng giao tiếp với khách hàng từ trắc nghiệp DISC'
        },
        {
          url: 'https://agent.rever.vn/blog/livestream-ban-hang-bat-dong-san-vu-khi-moi-cho-dan-sale-giua-mua-dich',
          thumbnail: 'https://agent.rever.vn/hubfs/2-Aug-12-2021-03-24-09-97-PM.png',
          title: 'Livestream bán hàng bất động sản, vũ khí mới cho dân sale giữa mùa dịch'
        },
        {
          url: 'https://agent.rever.vn/blog/phan-mem-quan-ly-khach-hang',
          thumbnail: 'https://agent.rever.vn/hubfs/agreement-business-businessman-872957.jpg',
          title: 'Phần mềm quản lý khách hàng Rever: Những tính năng vượt trội'
        }
      ]
    }
  }
})
// const app = createApp(App)
app.component("v-select",vSelect)
//     .component("v-footer",VFooter)

app.directive('registerButton', {
  beforeMount(el, binding, vnode) {
    const { instance } = binding
    const { value = '' } = binding

    instance?.$nextTick(() => {
      const { registerForm } = instance.$refs
      console.log(instance)
      $(el)
          .off('click')
          .on('click', e => {
            console.log("hihihihihi");
            (instance.$refs.registerForm as InstanceType<typeof RegisterForm>).show(e, {
              class: [value].filter(v => !!v)
            })
          })
    })
  },
  updated(el, binding, vnode) {
    const { instance } = binding
    const { value = '' } = binding
    console.log("hihihihi")
    instance?.$nextTick(() => {
      const { registerForm } = instance.$refs
      console.log(instance)
      $(el)
          .off('click')
          .on('click', e => {
            console.log("hihihihihi");
            (instance.$refs.registerForm as InstanceType<typeof RegisterForm>).show(e, {
              class: [value].filter(v => !!v)
            })
          })
    })
  }
})

// app.use(VueLazyload)


app

    .mount("#app");

export default app
// app.mount('#app')
// app.directive('registerButton',{
//   bind: function(el:any, binding:any, vnode:any) {
//     const { context } = vnode
//     const { value = '' } = binding
//     context.$nextTick(() => {
//       const { registerForm } = context.$refs
//       $(el)
//         .off('click')
//         .on('click', e => {
//           registerForm.show(e, {
//             class: [value].filter(v => !!v)
//           })
//         })
//     })
//   },
//   update: function(el:any, binding:any, vnode:any) {
//     const { context } = vnode
//     const { value = '' } = binding
//     context.$nextTick(() => {
//       const { registerForm } = context.$refs
//       $(el)
//         .off('click')
//         .on('click', e => {
//           registerForm.show(e, {
//             class: [value].filter(v => !!v)
//           })
//         })
//     })
//   }
// })

// const app = {
//   el: '#app',
//   components: { VFooter, ReadyForRegister, RegisterForm, OwlCarousel },
//   mixins: [Mixin],
//   mounted: function() {
//     $('a[href="#"]').click(e => {
//       e.preventDefault()
//     })
//
//     $('#toplinks').on('click', 'a', function(event) {
//       event.preventDefault()
//       var o = $($(this).attr('href')).offset()
//       var sT = o.top - 60
//       window.scrollTo(0, sT)
//     })
//   },
//   data: {
//     openSidenav: false
//   },
//   watch: {
//     openSidenav() {
//       if (this.openSidenav()) {
//         $('.bg-over').fadeIn(250)
//       } else {
//         $('.bg-over').fadeOut(350)
//       }
//     }
//   },
//   computed: {
//     relatedPostOptions() {
//       return {
//         loop: true,
//         margin: 10,
//         nav: false,
//         autoplay: true,
//         autoplayTimeout: 8000,
//         responsive: {
//           0: {
//             items: 1
//           },
//           768: {
//             items: 2
//           },
//           1000: {
//             items: 3
//           }
//         }
//       }
//     },
//     danhgiaOptions() {
//       return {
//         loop: true,
//         margin: 10,
//         nav: true,
//         autoplay: true,
//         autoplayTimeout: 10000,
//         responsive: {
//           0: {
//             items: 1
//           },
//           768: {
//             items: 1
//           },
//           1000: {
//             items: 1
//           }
//         }
//       }
//     },
//     agents(): object[] {
//       return [
//         {
//           thumbnail: `${this.baseUrl}images/hv1.jpg`,
//           name: 'Nguyễn Thị Dịu',
//           job_title: 'Sales Agent',
//           description:
//             'Giảng viên của lớp Red16 có một cách truyền đạt rất sát với tâm lý của học viên. Giảng viên chia sẻ rất nhiệt tình về những kinh nghiệm quý báu của mình để các học viên được truyền cảm hứng và động lực.'
//         },
//         {
//           thumbnail: `${this.baseUrl}images/hv2.png`,
//           name: 'Trần Thị Mai Uyên',
//           job_title: 'Sales Agent',
//           description:
//             'Môi giới bất động sản không chỉ là một cơ hội việc làm mà còn là một sự nghiệp. Red16 không chỉ mang đến Kiến thức, kinh nghiệm để tạo niềm tin, sự tự chủ trong nghề nghiệp mà còn giúp người môi giới tạo ra thu nhập trong quá trình học.'
//         },
//         {
//           thumbnail: `${this.baseUrl}images/hv3.png`,
//           name: 'Huỳnh Phúc Thanh',
//           job_title: 'Sales Manager',
//           description:
//             'Khóa học chưa kết thúc nhưng đã có học viên đạt từ ba đến bốn giao dịch thật sự, đó không chỉ là thành quả do chính học viên tạo ra mà còn đến từ những kiến thức hữu ích và quý giá của giáo trình Red16.'
//         }
//       ]
//     },
//     articles() {
//       return [
//         {
//           url: 'https://agent.rever.vn/blog/rut-ngan-khoang-cach-thanh-cong-bang-lo-trinh-dao-tao-chuyen-sau-tai-rever',
//           thumbnail: 'https://agent.rever.vn/hubfs/VN_08629.jpg',
//           title: 'Rút ngắn khoảng cách thành công bằng lộ trình đào tạo chuyên sâu tại Rever'
//         },
//         {
//           url: 'https://agent.rever.vn/blog/khoa-hoc-moi-gioi',
//           thumbnail: 'https://agent.rever.vn/hubfs/unnamed%20%281%29-Feb-11-2022-06-32-04-64-AM.jpg',
//           title: '5 lý do bạn nên tham dự một khóa học môi giới'
//         },
//         {
//           url: 'https://agent.rever.vn/blog/bi-quyet-trau-doi-ky-nang-giao-tiep-voi-khach-hang-tu-trac-nghiem-disc',
//           thumbnail:
//             'https://agent.rever.vn/hubfs/X%C3%A2y%20d%E1%BB%B1ng%20k%E1%BB%B9%20n%C4%83ng%20giao%20ti%E1%BA%BFp%20v%E1%BB%9Bi%20kh%C3%A1ch%20h%C3%A0ng%20ti%E1%BB%81m%20t%E1%BB%AB%20tr%E1%BA%AFc%20nghi%E1%BB%87m%20DISC%20%282%29.png',
//           title: 'Bí quyết trau dồi kỹ năng giao tiếp với khách hàng từ trắc nghiệp DISC'
//         },
//         {
//           url: 'https://agent.rever.vn/blog/livestream-ban-hang-bat-dong-san-vu-khi-moi-cho-dan-sale-giua-mua-dich',
//           thumbnail: 'https://agent.rever.vn/hubfs/2-Aug-12-2021-03-24-09-97-PM.png',
//           title: 'Livestream bán hàng bất động sản, vũ khí mới cho dân sale giữa mùa dịch'
//         },
//         {
//           url: 'https://agent.rever.vn/blog/phan-mem-quan-ly-khach-hang',
//           thumbnail: 'https://agent.rever.vn/hubfs/agreement-business-businessman-872957.jpg',
//           title: 'Phần mềm quản lý khách hàng Rever: Những tính năng vượt trội'
//         }
//       ]
//     }
//   }
// }
